import React from "react";
import ImportExport from "./ImportExport";

export default function ImportWorkspace(props) {
  return <ImportExport {...props} mode="import" />;
}
